import HeaderPortal from "components/portal/header-portal";
import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import { StatusCell } from "@/components/status/cell";
import { EmployeeCell } from "components/cell/employee/cell";
import { getEmployeeFields } from "components/user/config";

export default function Teams() {

  const columns = [
    {
      id: "lead",
      header: "Lead",
      accessorKey: "lead",
      cell: EmployeeCell,
    },
    {
      header: "Employees",
      id: "employee",
      meta: {
        subRowAccessor: true,
      },
      cell: ({ row }) => {
        const employees = row.original?.employees;
        if (!employees || employees.length === 0) return null;
        return (
          <div className="flex -space-x-1.5 overflow-hidden">
            {employees?.map((employeeData) => (
              <EmployeeCell
                key={employeeData.employee.id}
                getValue={() => employeeData.employee}
              />
            ))}
          </div>
        );
      },
    },
    {
      id: "department",
      header: "Department",
      accessorKey: "department.name",
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
  ];

  const fields = [
    "id",
    getEmployeeFields("lead"),
    "status",
    "department.name",
    getEmployeeFields("employees.employee"),
  ];

  return (
    <div className="w-full">
      <HeaderPortal>
        <PermissionControlledInput
          rule={"create:*"}
          collection="teams"
          showWhenDisabled={false}
        >
          <CreateItemButton href>Team</CreateItemButton>
        </PermissionControlledInput>
      </HeaderPortal>
      <div className="flex-1 h-full">
        <List
          title="Teams"
          endPoint="teams"
          columns={columns}
          meta={{
            fields,
          }}
          sortBy="department.name"
          sortOrder="aesc"
          href={(item) => item.id}
        />
      </div>
    </div>
  );
}
